module.exports = __webpack_public_path__ + "img/write.86715292.png";